import React from 'react';
import Header from '../../../../Header';
import Footer from '../../../../Footer';
import SingleAmountCalculator from './SingleAmountCalculator';

const SingleAmountInfo = () => {
  return (
    <div className="bg-[#FFFFFF] rounded-lg shadow-lg p-6">
      <h2 className="text-[#1C52A0] text-2xl font-semibold mb-4">Single Amount Investment Returns Calculator</h2>
      <p className="mb-4 text-[#0D0D0D]">The Single Amount Investment Returns Calculator helps you determine the future value of a one-time investment. It provides a quick and accurate assessment of how your investment will grow over time, helping you make informed financial decisions.</p>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Key Components</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Initial Investment Amount</li>
        <li>Investment Period</li>
        <li>Annual Interest Rate</li>
        <li>Compounding Frequency</li>
        <li>Future Value</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">How It Works</h3>
      <p className="mb-4 text-[#0D0D0D]">The calculator uses a comprehensive approach to determine your investment returns:</p>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Calculates compound interest over time</li>
        <li>Considers different compounding frequencies</li>
        <li>Shows growth of investment over periods</li>
        <li>Provides annualized returns</li>
        <li>Generates detailed investment analysis</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Benefits</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Understand investment growth</li>
        <li>Compare different investment periods</li>
        <li>Analyze impact of interest rates</li>
        <li>Plan long-term investments</li>
        <li>Track investment performance</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Using the Calculator</h3>
      <p className="mb-4 text-[#0D0D0D]">Enter your initial investment amount, desired investment period, annual interest rate, and compounding frequency to calculate the future value of your investment. The calculator will provide a detailed analysis of how your investment will grow over time.</p>
    </div>
  );
};

const SingleAmount = () => {
  return (
    <>
      <Header/>
      <main className="overflow-x-hidden">
        <div className="relative z-20">
          <SingleAmountCalculator/>
        </div>
        <SingleAmountInfo />
      </main>
      <div className="relative z-20">
        <Footer />
      </div>
    </>
  );
};

export default SingleAmount;